import React from "react";

import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";
type OutlinedInputProps = {
  label: string;
  children: React.ReactNode;
  required?: boolean;
  fullWidth?: boolean;
  forceBigText?: boolean;
  error?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
const InputComponent = ({ inputRef, ...other }: any) => <div {...other} />;
const Outlined : React.FC<OutlinedInputProps> =
({ children, label, required, fullWidth, error }: OutlinedInputProps) => (
  <TextField
    error={!!error}
    fullWidth={!!fullWidth}
    required={!!required}
    margin="dense"
    label={label}
    multiline
    slotProps={{ inputLabel: {
      shrink: true,
    },
    input: {
      inputComponent: InputComponent,
    },
    htmlInput: { children } }}
  />
);
const OutlinedWithText : React.FC<OutlinedInputProps> =
({ children, label, required, fullWidth, error }: OutlinedInputProps) => (
  <Outlined label="" fullWidth={!!fullWidth} required={!!required} error={!!error}>
    <Typography
      variant="subtitle1"
      className={`MuiFormLabel-root ${error ? "color-hc-error" : ""}`}
    >{label + (required ? "*" : "")}</Typography>
    {children}
  </Outlined>
);

const OutlinedDiv : React.FC<OutlinedInputProps> =
({ children, ...props }: OutlinedInputProps) => {
  const Component = (props.label.length > 40 || props.forceBigText) ? OutlinedWithText : Outlined;
  return <Component {...props}>{props.forceBigText && <br />}{children}</Component>;
};
export default OutlinedDiv;
